import React from "react";
import {AuthProvider} from "./src/context/AuthProvider";

// Auth sits above the page element because the sign-in control now lives in the top bar
// (components/AsposeMenu/AppLogin), which wrap-page-element.js renders outside the page.
// wrapRootElement rather than wrapPageElement so the provider survives client-side
// navigation instead of re-running the OIDC and fingerprint lookups on every page change.
export const wrapRootElement = ({element}) => (
    <AuthProvider>
        {element}
    </AuthProvider>
);
